export function buildBreakUserTopic(username) {
    const trimmed = username.trim();
    if (!trimmed) {
        throw new Error('Break topic requires a username.');
    }
    return `/topic/break.user.${trimmed}`;
}
export function parseBreakEvent(raw) {
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object')
            return null;
        const event = parsed;
        if (typeof event.eventType !== 'string')
            return null;
        return {
            eventType: event.eventType,
            breakRecord: event.breakRecord && typeof event.breakRecord === 'object'
                ? event.breakRecord
                : undefined,
            endedBy: typeof event.endedBy === 'string' ? event.endedBy : undefined,
        };
    }
    catch {
        return null;
    }
}
